import auth from "../firebase/auth";
import {
  browserLocalPersistence,
  browserSessionPersistence,
  sendEmailVerification,
  setPersistence,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";

import db from "@/firebase/db";
import { doc, setDoc } from "firebase/firestore";

import store from "@/store";

export async function authLogin(payload) {
  await setPersistence(
    auth,
    payload.keepLoggedIn ? browserLocalPersistence : browserSessionPersistence
  );
  await signInWithEmailAndPassword(auth, payload.email, payload.password)
    .then(async (result) => {
      console.log('sign in');
      if (!result.user.emailVerified) {
        await sendEmailVerification(result.user);
      }
    })
    .catch((error) => {
      throw error;
    });
}

export async function authRegister(payload) {
  await setPersistence(
    auth,
    payload.keepLoggedIn ? browserLocalPersistence : browserSessionPersistence
  );
  const result = await createUserWithEmailAndPassword(
    auth,
    payload.email,
    payload.password
  );
  const user = result.user;
  await updateProfile(user, {
    displayName: payload.displayName,
  });
  if (!store.getters["user/getUser"].language) {
    auth.languageCode = navigator.language;
  }
  await sendEmailVerification(user);
  await setDoc(doc(db, "users", auth.currentUser.uid), {});
}

export async function authLogout() {
  await signOut(auth);
}
